import { render, staticRenderFns } from "./BtnDelete.vue?vue&type=template&id=bf9e5ea4&"
import script from "./BtnDelete.vue?vue&type=script&lang=js&"
export * from "./BtnDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports